import { css } from "@emotion/css";
import { AppButton, Dialog, Text } from "../../../components";
import { GoOfflineIllustration } from "../../../components/icons";
import React from "react";
import { removeTokens } from "../../../services";
import { E_Route } from "@repo-sapiens/constants";
import pubsub from "sweet-pubsub";
import { ENotificationKey } from "../../../utils/constants";

type Props = {
  children: React.ReactNode;
};
export const SignoutDialog: React.FC<Props> = ({ children }) => {
  const [open, onOpenChange] = React.useState(false);
  const handleLogout = () => {
    removeTokens();
    window.location.href = E_Route.AuthBegin;
  };
  return (
    <Dialog
      noClose
      additionalContent={
        <div
          className={css`
            display: flex;
            flex-direction: column;
            align-items: center;
          `}
        >
          <GoOfflineIllustration />
          <div
            className={css`
              width: 60%;
              margin-bottom: 24px;
            `}
          >
            <Text.Body
              style={{
                color: "#909090",
                textAlign: "center",
              }}
            >
              You are about to log out of Multiplayer. Are you sure?
            </Text.Body>
          </div>
          <AppButton onClick={handleLogout}>Quit</AppButton>
          <Text.Body
            style={{
              textAlign: "center",
              opacity: 0.5,
              cursor: "pointer",
              marginTop: "24px",
            }}
            onClick={() => {
              pubsub.emit(ENotificationKey.SHOW_DROPDOWN, { value: false });

              onOpenChange?.(false);
            }}
          >
            Play Again
          </Text.Body>
        </div>
      }
      open={open}
      onOpenChange={onOpenChange}
    >
      <div
        className={css`
          width: 100%;
        `}
      >
        {children}
      </div>
    </Dialog>
  );
};
